import { takeEvery, put, call, select } from "redux-saga/effects";
import type { SagaIterator } from "redux-saga";
import { Api } from "../../api/api";
import { API_ENDPOINTS } from "../../api/endpoints";
import {
  fetchStylists,
  fetchStylistsSuccess,
  fetchStylistsFailure,
  type Stylist,
} from "../slices/stylistSlice";
import type { RootState } from "../index";

// Fetch stylists saga
function* handleFetchStylists(): SagaIterator<void> {
  try {
    // Get franchise info from Redux state
    const { franchiseId, userId }: { franchiseId: string | null; userId: string | null } = yield select(
      (state: RootState) => state.stylist
    );
    
    if (!franchiseId || !userId) {
      yield put(fetchStylistsFailure("Franchise ID and User ID are required"));
      return;
    }
    
    // Call API with custom headers
    // Note: Api.get signature is (url, params, headers)
    const response: { success: boolean; message: string; data: Stylist[]; error: null } = yield call(
      Api.get,
      API_ENDPOINTS.FRANCHISE.STYLISTS,
      undefined, // params
      {
        franchiseid: franchiseId,
        userId: userId,
      }
    );
    
    // Dispatch success action with stylist data from response.data
    yield put(fetchStylistsSuccess(response.data));
  } catch (error: any) {
    // Dispatch failure action with error message
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to fetch stylists";
    yield put(fetchStylistsFailure(errorMessage));
    console.error("Fetch stylists error:", error);
  }
}

// Watcher saga - watches for fetchStylists actions
export function* watchStylists(): SagaIterator<void> {
  yield takeEvery(fetchStylists.type, handleFetchStylists);
}
